<template>
  <v-data-table
      :headers="headers"
      :items="medications"
      :search="search"
      :items-per-page="-1"
      :custom-filter="customFilter"
      :class="$style['medications-table']"
      @click:row="editItem"
  >
    <template v-slot:item.medication="{ item }">
      {{item.medication}}
      <p class="mb-0"><small>{{ item.medicationName }}</small></p>
    </template>
    <template v-slot:item.routes="{ item }">
      <v-chip
          v-for="route in item.routes"
          :key="route"
          class="ma-1"
          small
      >
        {{route}}
      </v-chip>
    </template>
    <template v-slot:item.allowOtherRoutes="{ item }">
      <v-simple-checkbox
          v-model="item.allowOtherRoutes"
          style="pointer-events: none"
          disabled
      ></v-simple-checkbox>
    </template>
    <template v-slot:item.doseUnits="{ item }">
      <v-chip
          v-for="doseUnit in item.doseUnits"
          :key="doseUnit"
          class="ma-1"
          small
      >
        {{doseUnit}}
      </v-chip>
    </template>
    <template v-slot:item.allowOtherUnits="{ item }">
      <v-simple-checkbox
          v-model="item.allowOtherUnits"
          style="pointer-events: none"
          disabled
      ></v-simple-checkbox>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'MedicationsTable',
  props: {
    medications: {
      type: Array,
      required: true,
    },
    search: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'Medication',
          value: 'medication',
          width: '20%',
        },
        {
          text: 'Routes',
          value: 'routes',
          width: '20%',
        },
        {
          text: 'Allowed Other Routes',
          value: 'allowOtherRoutes',
          width: '20%',
        },
        {
          text: 'Dose Units',
          value: 'doseUnits',
          width: '20%',
        },
        {
          text: 'Allow Other Units',
          value: 'allowOtherUnits',
          width: '20%',
        },
      ],
    };
  },

  methods: {
    editItem(item) {
      this.$emit('editMedication', item);
    },
    customFilter(value, search, item) {
      return (
        item.medication.toLowerCase().includes(search.toLowerCase())
          || item.medicationName.toLowerCase().includes(search.toLowerCase())
          || item.routes.some(route => route.toLowerCase().includes(search.toLowerCase())
              || item.doseUnits.some(unit => unit.toLowerCase().includes(search.toLowerCase())))
      );
    },
  },
};
</script>

<style lang="scss" module>
.medications-table {
  tbody tr {
    cursor: pointer;
  }
}
</style>
